export default "__VITE_ASSET__cf5eb152__"